module.exports = __webpack_public_path__ + "img/noice-icon.651e3146.svg";